import { INTERVIEW_DRAWER_MODES } from 'features/sendouts/components/drawers/SendoutInterviewDrawer/SendoutInterviewDrawer.constants';

import { DRAWER_TYPES } from '../../components';

export const buildSendoutsDrawerNavigator = ({ openDrawer, jobOrder, onPlacementCreated }) => {
  const nav = {};

  const openDuplicates = ({ candidate }) => {
    openDrawer(DRAWER_TYPES.Duplicates, {
      jobOrder,
      candidate,
      onOpenSendoutDetails: nav.openSendoutDetails,
      onOpenSendoverDetails: nav.openSendoverDetails
    });
  };

  nav.openCreateCall = () => {
    openDrawer(DRAWER_TYPES.CreateCall, { jobOrder });
  };

  nav.openCallList = () => {
    openDrawer(DRAWER_TYPES.CallList, {
      // TODO: CallList/CreateCall are placeholders for now
      onCreateCall: () => nav.openCreateCall(null),
      onEditCall: callId => nav.openCreateCall(callId)
    });
  };

  nav.openSendoutInterviewDetails = ({ interviewId, mode, onCustomSubmitSuccess, sendoutId }) => {
    openDrawer(DRAWER_TYPES.SendoutInterviewDetails, {
      interviewId,
      mode,
      onCustomSubmitSuccess,
      sendoutId
    });
  };

  nav.openSendoutDetails = ({ sendoutId }) => {
    openDrawer(DRAWER_TYPES.SendoutDetails, {
      sendoutId,
      onOpenCalls: nav.openCallList,
      onStartPlacement: () => nav.openCreatePlacement({ sendoutId }),
      onEditDetails: refreshData =>
        openDrawer(DRAWER_TYPES.SendoutDetailsEdit, {
          sendoutId,
          jobOrder,
          onCustomSubmitSuccess: refreshData
        }),
      onScheduleInterview: refreshInterviews =>
        openDrawer(DRAWER_TYPES.CreateSendoutInterview, {
          sendoutId,
          onCustomSubmitSuccess: refreshInterviews
        }),
      onViewInterviewDetails: ({ interviewId }) =>
        nav.openSendoutInterviewDetails({
          interviewId,
          mode: INTERVIEW_DRAWER_MODES.View,
          sendoutId
        }),
      onEditInterview: ({ interviewId, refreshInterviews }) =>
        nav.openSendoutInterviewDetails({
          interviewId,
          mode: INTERVIEW_DRAWER_MODES.Edit,
          onCustomSubmitSuccess: refreshInterviews,
          sendoutId
        })
    });
  };

  nav.openSendoverDetails = ({ sendoverId }) => {
    openDrawer(DRAWER_TYPES.SendoverDetails, {
      sendoverId,
      onConvertToSendout: nav.openConvertSendoverToSendout,
      onEditDetails: refreshData =>
        openDrawer(DRAWER_TYPES.SendoverDetailsEdit, {
          sendoverId,
          onCustomSubmitSuccess: refreshData
        })
    });
  };

  nav.openConvertSendoverToSendout = ({ sendover, switchType }) => {
    openDrawer(DRAWER_TYPES.ConvertSendoverToSendout, {
      sendover,
      switchType,
      jobOrderId: jobOrder?.id,
      onViewDuplicates: openDuplicates
    });
  };

  nav.openCreateSendout = () => {
    openDrawer(DRAWER_TYPES.CreateSendout, {
      jobOrderId: jobOrder?.id,
      onViewDuplicates: openDuplicates
    });
  };

  nav.openCreatePlacement = ({ sendoutId }) => {
    openDrawer(DRAWER_TYPES.CreatePlacement, {
      sendoutId: Number(sendoutId),
      jobOrderId: jobOrder?.id,
      companyId: jobOrder?.company?.id,
      onCompleted: () => onPlacementCreated({ jobOrderId: jobOrder?.id }),
      onNewSendout: nav.openCreateSendout
    });
  };

  nav.openCreateSendover = () => {
    openDrawer(DRAWER_TYPES.CreateSendover, {
      jobOrderId: jobOrder?.id,
      onViewDuplicates: openDuplicates
    });
  };

  return nav;
};
